<template>
  <div class="page_msg container">
    <div class="header_gruop page_width flex_sb">
      <div class="icon_home flex_center"><svg t="1729563443244" class="icon" viewBox="0 0 1024 1024" version="1.1"
          xmlns="http://www.w3.org/2000/svg" p-id="6080" id="mx_n_1729563443245" width="16" height="16">
          <path
            d="M398.912 513.152l377.28-384.256c27.904-28.416 27.904-74.432 0-102.784-27.84-28.352-73.024-28.352-100.8 0L247.808 461.504C233.792 475.776 226.88 494.464 226.944 513.152 226.88 531.84 233.792 550.464 247.808 564.736l427.584 435.392c27.84 28.352 73.024 28.352 100.8 0 27.904-28.352 27.904-74.368 0-102.656L398.912 513.152z"
            fill="#16181c" p-id="6081"></path>
        </svg></div>
      <div class="header_title">Pay</div>
      <div></div>
    </div>
    <div class="airwallex-apple-pay">
      <h1 class="hclass">ApplePay</h1>
      <div id="applePayButton"></div>
    </div>
    <div class="airwallex-google-pay">
      <h1  class="hclass">GooglePay</h1>
      <div id="googlePayButton"></div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      applePayElement: null, // 存储 Apple Pay 元素实例
      googlePayElement: null,
      totalPay: '',
      intent_id: '',
      client_secret: '',
      amountCurrency: '',
      amountValue: '',
    }
  },
  beforeDestroy() {
    this.cleanupAirwallex();

  },
  methods: {
    async initAirwallexApplePay() {
      try {
        if (!window.AirwallexComponentsSDK) {
          throw new Error('Airwallex Components SDK 未加载，请先引入对应的 CDN 脚本');
        }
        await window.AirwallexComponentsSDK.init({
          // env: 'demo',
          env: 'prod', //生产
          enabledElements: ['payments'],
        });

        // 步骤 2：创建 Apple Pay 按钮实例
        this.applePayElement = await window.AirwallexComponentsSDK.createElement('applePayButton', {
          intent_id: this.intent_id,
          client_secret: this.client_secret,
          amount: {
            value: this.amountValue,
            currency: this.amountCurrency,
          },
          countryCode: 'US',
          methods: ['applepay'],
          // requiredBillingContactFields: ['JONATHAN LI','2862@163.com','NO.23 ANDELINORTH STREET'],
          // withBilling:true,
        });

        this.applePayElement.mount('applePayButton');
        this.applePayElement.on('ready', (event) => {
          console.log('Apple Pay 按钮就绪：', event.detail);
          // alert('Apple Pay 按钮已就绪，可以发起支付');
        });
        this.applePayElement.on('success', (event) => {
          // console.log('支付成功：', event.detail);
          // alert('Payment successful');
          console.log('支付成功：', event.detail,event.detail.intent,event.detail.intent.return_url);
          window.location.href = event.detail.intent.return_url
        });
        this.applePayElement.on('error', (event) => {
          console.log('支付失败：', event);
          alert('Payment failed');
        });
      } catch (error) {
        // alert(`初始化失败：${error.message}`);
      }

    },

    async initAirwallexgooglePay() {
      try {
        if (!window.AirwallexComponentsSDK) {
          throw new Error('Airwallex Components SDK 未加载，请先引入对应的 CDN 脚本');
        }
        await window.AirwallexComponentsSDK.init({
          env: 'prod',
          enabledElements: ['payments'],
        });

        this.googlePayElement = await window.AirwallexComponentsSDK.createElement('googlePayButton', {
          intent_id: this.intent_id,
          client_secret: this.client_secret,
          amount: {
            value: this.amountValue,
            currency: this.amountCurrency,
          },
          autoCapture: true,
          merchantInfo: {
            merchantName: 'ARI2_PAY-Merchant',
          },
          countryCode: 'US',

        });

        // requiredBillingContactFields: ['jusn li','2862@163.com']
        // withBilling:true,
        this.googlePayElement.mount('googlePayButton');
        this.googlePayElement.on('ready', (event) => {
          console.log('google Pay 按钮就绪：', event.detail);
          // alert('google Pay 按钮已就绪，可以发起支付');
        });
        this.googlePayElement.on('success', (event) => {
          console.log('支付成功：', event.detail,event.detail.intent,event.detail.intent.return_url);
          // alert('Payment successful');
          window.location.href = event.detail.intent.return_url
        });
        this.googlePayElement.on('error', (event) => {
          console.log('Payment failed', event);
          // alert('Payment failed');
          alert(`Payment failed: ${event.detail.error.message}`);
        });
      } catch (error) {
        // alert(`初始化失败：${error.message}`);
      }

    },

    // 清理资源：避免内存泄漏
    cleanupAirwallex() {
      if (this.applePayElement) {
        this.applePayElement.off('ready');
        this.applePayElement.off('success');
        this.applePayElement.off('error');
        this.applePayElement.destroy();
        this.applePayElement = null;
      }
      if (this.googlePayElement) {
        this.googlePayElement.off('ready');
        this.googlePayElement.off('success');
        this.googlePayElement.off('error');
        this.googlePayElement.destroy();
        this.googlePayElement = null;
      }
    },
    paytype() {
      // let params = {
      //   orderNum: this.orderNum
      // }
      // let res = {
      //     "code": 200,
      //     "data": {
      //       "respCode": 10002,
      //       "respMessage": "wait",
      //       "agentId": null,
      //       "orderNo": null,
      //       "orderNum": "hs202512021259080521341vJd",
      //       "amount": null,
      //       "currency": null,
      //       "payUrl": null,
      //       "payTime": null,
      //       "billInfo": null,
      //       "sign": null
      //     },
      //     "message": "success"
      //   }
      // res.data.data
      this.$axios.get('https://www.omniresourcebuy.com/v1.0/evoOrderDs', {
        params: {
          orderNum: this.orderNum,
        }
      }).then((res) => {
        res = res.data
        this.respCode = res.data.respCode
        if (res.data.respCode == '10002') {
          this.respCode = '100002'
        } else if (res.data.respCode == '10000') {
          if (res.data.payUrl) {
            window.location.href = res.data.payUrl;
          }
        } else if (res.data.respCode == '10001') {
          if (res.data.payUrl) {
            window.location.href = res.data.payUrl;
          }
        }

      })
    }
  },
  watch: {
    // respCode: {
    //     handler(newVal, oldVal) {
    //       if (this.respCode == '100002' && this.respCodeNum <= 10) {
    //         setTimeout(() => {
    //           this.paytype()
    //           this.respCodeNum = this.respCodeNum + 1
    //           console.log(this.respCodeNum);
    //         }, 800);
    //       } else {
    //         this.$message({
    //             message: 'Payment processing in progress',
    //             offset: '100',
    //             center: true,
    //             iconClass: 'cas'
    //           })
    //       }
    //     },
    //     deep: true
    //   }
  },
  async mounted() {
    this.intent_id = this.$route.query.orderNum
    this.client_secret = this.$route.query.secret
    this.amountCurrency = this.$route.query.currency
    this.amountValue = this.$route.query.amount
    // this.totalPay = sessionStorage.getItem('totalPay')
    await this.initAirwallexApplePay();
    await this.initAirwallexgooglePay();
    console.log(this.$route.query, '9999999999999999999999999999','88');
  },


}
</script>
<style>
.cas {
  display: none;
  color: #ccc;
}

.airwallex-apple-pay, .airwallex-google-pay {
  padding: 30px 30px 0;
}
.hclass {
  font-size: 20px;
  padding: 20px;
}

</style>
